import { render } from "./Items.vue?vue&type=template&id=081f9b50&scoped=true"
import script from "./Items.vue?vue&type=script&lang=js"
export * from "./Items.vue?vue&type=script&lang=js"

import "./Items.vue?vue&type=style&index=0&id=081f9b50&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081f9b50"]])

export default __exports__